module.exports = __webpack_public_path__ + "img/05-img.03050e8e.jpg";